import { ref } from "vue"

export function useTabsDefinitions() {
	const assessmentDetails = ref("Assessment Details")
	const syntheticAPI = ref("Synthetic API")
	const biologics = ref("Biologics")
	const productProcess = ref("Product Process")
	const packaging = ref("Device & Packaging")
	const distribution = ref("Distribution")
	const consumerEndOfLife = ref("Consumer End of Life")
	const lifecycleSummaryResult = ref("LifeCycle Summary Result")
	return {
		assessmentDetails,
		syntheticAPI,
		biologics,
		productProcess,
		packaging,
		distribution,
		consumerEndOfLife,
		lifecycleSummaryResult,
	}
}
export function useSubTabsDefinitions() {
	const deviceMaterials = ref({ label: "Device Materials", id: "11b05cc3-a137-4e55-ac1a-3857bc54f2f6" })
	const packagingMaterials = ref({ label: "Packaging Materials", id: "7ea1c8ac-b0b6-4dd8-b046-62f15f8005ad" })
	const downstreamPackagingMaterials = ref({ label: "Downstream Packaging Materials", id: "3605104b-9e1b-48a8-8ad4-05798f22e74f" })
	return {
		deviceMaterials,
		packagingMaterials,
		downstreamPackagingMaterials,
	}
}
